import PageLayout from "examples/LayoutContainers/PageLayout";
import Footer from "layouts/authentication/components/Footer";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import { Box, Container, Grid, Typography } from "@mui/material";
import SoftTypography from "components/SoftTypography";
export interface PageData {
  page_id: number;
  client_id: number;
  page_name: string;
  page_route: string;
  page_title: string;
  page_description: string;
  page_icon: string | null;
  page_image: string | null;
  is_active: number;
  created_at: string;
  updated_at: string;
}

const ReUsePage = ({ pageData }: { pageData: PageData }) => {
  const imageUrl = pageData?.page_image
    ? `${process.env.REACT_APP_CLOUD_FRONT_URL}/${pageData.page_image}`
    : "assets/images/aboutus.jpg";

  return (
    <PageLayout>
      <DefaultNavbar />
      <Box component="section" className="about-us" py={8}>
        <Container>
          <Grid container item xs={12} lg={12} sx={{ mx: "auto" }}>
            <Grid item xs={12} md={6}>
              <Box textAlign="center" lineHeight={1}>
                <img
                  src={imageUrl}
                  alt="About Us"
                  height="300px"
                  style={{ width: "100%" }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box pl={4} pt={4} lineHeight={1}>
                <SoftTypography variant="h2" textGradient>
                  {pageData?.page_title}
                </SoftTypography>
                <Typography variant="body2" color="text" mb={3}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        pageData?.page_description || "No description found",
                    }}
                  />
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Footer />
    </PageLayout>
  );
};

export default ReUsePage;
